import { Routes, Route, Navigate } from 'react-router-dom'
import { RequireAdminAuth } from '@/components/RequireAdminAuth'
import LoginPage from '@/pages/LoginPage'
import DashboardPage from '@/pages/DashboardPage'
import BrandsPage from '@/pages/BrandsPage'
import BrandDetailPage from '@/pages/BrandDetailPage'
import SubscriptionsPage from '@/pages/SubscriptionsPage'
import OrderManagementPage from '@/pages/OrderManagementPage'
import EmployeesPage from '@/pages/EmployeesPage'
import NotesPage from '@/pages/NotesPage'
import QuotaLogsPage from '@/pages/QuotaLogsPage'
import LoginLogsPage from '@/pages/LoginLogsPage'

/**
 * Admin 后台根组件 - 路由配置
 *
 * 路由结构：
 * /login           → LoginPage（无需认证）
 * /dashboard       → DashboardPage（需认证）
 * /brands          → BrandsPage（需认证）
 * /brands/:id      → BrandDetailPage（需认证）
 * /subscriptions   → SubscriptionsPage（需认证）
 * /                → Navigate to /dashboard
 */
function App() {
  return (
    <Routes>
      {/* 登录页（无需认证） */}
      <Route path="/login" element={<LoginPage />} />

      {/* 以下路由需要认证 */}
      <Route
        path="/dashboard"
        element={
          <RequireAdminAuth>
            <DashboardPage />
          </RequireAdminAuth>
        }
      />
      <Route
        path="/brands"
        element={
          <RequireAdminAuth>
            <BrandsPage />
          </RequireAdminAuth>
        }
      />
      <Route
        path="/brands/:id"
        element={
          <RequireAdminAuth>
            <BrandDetailPage />
          </RequireAdminAuth>
        }
      />
      <Route
        path="/subscriptions"
        element={
          <RequireAdminAuth>
            <SubscriptionsPage />
          </RequireAdminAuth>
        }
      />
      <Route
        path="/orders"
        element={
          <RequireAdminAuth>
            <OrderManagementPage />
          </RequireAdminAuth>
        }
      />
      <Route
        path="/employees"
        element={
          <RequireAdminAuth>
            <EmployeesPage />
          </RequireAdminAuth>
        }
      />
      <Route
        path="/notes"
        element={
          <RequireAdminAuth>
            <NotesPage />
          </RequireAdminAuth>
        }
      />
      <Route
        path="/quota-logs"
        element={
          <RequireAdminAuth>
            <QuotaLogsPage />
          </RequireAdminAuth>
        }
      />
      <Route
        path="/login-logs"
        element={
          <RequireAdminAuth>
            <LoginLogsPage />
          </RequireAdminAuth>
        }
      />

      {/* 默认跳转 */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}

export default App
